import last from 'lodash/last';
import first from 'lodash/first';

import { ItemType } from 'Shared/constants/types';

export enum MoveType {
  toTop = 'to_top',
  toBottom = 'to_bottom',
}

function getFuncByMoveType(moveType) {
  switch (moveType) {
    case MoveType.toBottom:
      return last;
    case MoveType.toTop:
    default:
      return first;
  }
}

export function getHoveredItemUuid({ meetingItem, sortedTypedItems, moveType }) {
  const { isHighPriority: isHighPriorityItemAttr, parentUuid, itemType } = meetingItem;
  const isDiscussionTopic = itemType === ItemType.discussionTopic;
  const isHighPriority = isDiscussionTopic ? false : isHighPriorityItemAttr;
  const getHoveredItem = getFuncByMoveType(moveType);
  let hoveredItemUuid;

  if (isHighPriority && !parentUuid) {
    hoveredItemUuid = getHoveredItem(
      sortedTypedItems.filter(
        ({ isHighPriority: isHighPriorityAttr, parentUuid: parentUuidAttr }) => isHighPriorityAttr && !parentUuidAttr
      )
    )?.uuid;
  } else if (!parentUuid) {
    hoveredItemUuid = getHoveredItem(
      sortedTypedItems.filter(
        ({ isHighPriority: isHighPriorityAttr, parentUuid: parentUuidAttr }) =>
          (isDiscussionTopic || !isHighPriorityAttr) && !parentUuidAttr
      )
    )?.uuid;
  } else if (parentUuid) {
    const restChildrens = sortedTypedItems.filter(
      ({ parentUuid: childrenParentUuid }) => childrenParentUuid === parentUuid
    );
    hoveredItemUuid = getHoveredItem(restChildrens)?.uuid;
  }
  return hoveredItemUuid;
}
